/* eslint-disable react/require-default-props */
import React from 'react';
import { bool, number as numberType, string as stringType } from 'prop-types';
import { ImpressionProvider } from '@thd-olt-component-react/impression';

/*
 * This is a Higher Order Component (HOC) that returns the component wrapped in an ImpressionProvider.
 */
const withImpressions = (Component) => {
  const Sub = ({
    componentClass = '', componentId, componentPosition = 1, lazyLoad = false, enableB2CRadius = false
  }) => {
    return (
      <ImpressionProvider
        data={{
          id: componentId,
          name: 'InternalMarketingBanner',
          component: 'InternalMarketingBanner',
          type: 'content'
        }}
      >
        <Component
          componentClass={componentClass}
          componentId={componentId}
          componentPosition={componentPosition}
          lazyLoad={lazyLoad}
          enableB2CRadius={enableB2CRadius}
        />
      </ImpressionProvider>
    );
  };

  Sub.propTypes = {
    componentClass: stringType,
    componentId: stringType.isRequired,
    componentPosition: numberType,
    lazyLoad: bool,
    enableB2CRadius: bool
  };

  return Sub;
};

export { withImpressions };
